import React, { useMemo, useState } from "react";
import { CommitmentRow } from "./CommitmentRow";
import { stateOf } from "../lib/api";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "open", label: "Open" },
  { key: "due_today", label: "Due Today" },
  { key: "due_soon", label: "Due Soon" },
  { key: "overdue", label: "Overdue" },
  { key: "conditional", label: "Conditional" },
  { key: "fulfilled", label: "Fulfilled" },
];

export const LedgerColumn = ({ title, subtitle, commitments, direction, onOpen, sharedFilter }) => {
  const [localFilter, setLocalFilter] = useState("all");
  const filter = sharedFilter || localFilter;

  const filtered = useMemo(() => {
    const list = commitments.filter((c) => c.direction === direction);
    if (filter === "all") return list.filter((c) => !["dismissed", "cancelled"].includes(c.status));
    if (filter === "dismissed") return list.filter((c) => c.status === "dismissed");
    if (filter === "cancelled") return list.filter((c) => c.status === "cancelled");
    if (filter === "blocked") return list.filter((c) => c.status === "blocked");
    if (filter === "partially_fulfilled") return list.filter((c) => c.status === "partially_fulfilled");
    return list.filter((c) => {
      const s = stateOf(c);
      // "open" filter shows all not-fulfilled/not-dismissed
      if (filter === "open") return !["fulfilled", "dismissed", "cancelled"].includes(s);
      return s === filter;
    });
  }, [commitments, direction, filter]);

  return (
    <section data-testid={`ledger-column-${direction}`} className="flex flex-col">
      <div className="flex items-baseline justify-between border-b-2 border-ledger-ink pb-3">
        <div>
          <h2 className="font-display text-3xl text-ledger-ink" data-testid={`column-title-${direction}`}>
            {title}
          </h2>
          <div className="mt-1 text-[11px] uppercase tracking-[0.18em] text-ledger-muted">
            {subtitle}
          </div>
        </div>
        <div className="font-mono text-sm text-ledger-sub" data-testid={`column-count-${direction}`}>
          {filtered.length} {filtered.length === 1 ? "entry" : "entries"}
        </div>
      </div>

      {!sharedFilter && false && (
        <div className="flex items-center gap-1 mt-3 mb-1 flex-wrap">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              data-testid={`filter-${direction}-${f.key}`}
              onClick={() => setLocalFilter(f.key)}
              className={
                "px-3 py-1 font-mono text-[11px] uppercase tracking-wider rounded-sm border transition-colors duration-150 " +
                (localFilter === f.key
                  ? "bg-ledger-ink text-white border-ledger-ink"
                  : "bg-white text-ledger-sub border-ledger-border hover:border-ledger-ink")
              }
            >
              {f.label}
            </button>
          ))}
        </div>
      )}

      <div className="mt-2 divide-y divide-ledger-border">
        {filtered.length === 0 && (
          <div className="py-16 text-center text-sm text-ledger-muted font-mono">
            No entries match this filter.
          </div>
        )}
        {filtered.map((c) => (
          <CommitmentRow key={c.id} commitment={c} onOpen={onOpen} />
        ))}
      </div>
    </section>
  );
};
